import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
  Signal,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@web/shared/module/auth';
import { Observable } from 'rxjs';
import { negate } from '@web/utils';
import { SlimButtonComponent } from '@web/shared/ui';
import {
  Route,
  RouteQueryParam,
  RouterLinkComponent,
  RouterLinkQueryParams,
} from '@web/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-public-guest-notice',
  imports: [CommonModule, SlimButtonComponent, RouterLinkComponent],
  templateUrl: './public-guest-notice.component.html',
  styleUrl: './public-guest-notice.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicGuestNoticeComponent {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  public readonly styleClass = input.required<string>();
  public readonly isNotLoggedIn$ = this.isLoggedInSource();

  protected readonly queryParams = this.queryParamsSignal();
  protected readonly Route = Route;

  private queryParamsSignal(): Signal<RouterLinkQueryParams> {
    return signal<RouterLinkQueryParams>({
      [RouteQueryParam.ReturnUrl]: this.router.url,
    });
  }

  private isLoggedInSource(): Observable<boolean> {
    return this.auth.isLoggedIn().pipe(negate());
  }
}
